import { gql } from '@apollo/client';
export const StatFeatureCareContract = gql `
    fragment StatFeatureCareContract on CareContractFeatureSettingsType {
        isEnabled
        noSigneeRestrictionsEnabled
    }
`;
